//import "./components/scroll-progress-indicator";
//import "../../features/article-continous-scroll";
import { hookGallery } from "../../features/fullscreen-gallery";
import { hookArticleComponents } from "../../features/hook-article-components";

const article = document.querySelector("article")!;
hookGallery(article);
hookArticleComponents(article);

import "../../components/livefeed";
